<div class="flex flex-auto flex-wrap gap-4">
    <!-- <p-button
        label="Ακύρωση"
        severity="secondary"
        (onClick)="visible = false"
    /> -->
    <!-- @if (showAddPaymentButton) {
        <p-button
            [outlined]="true"
            label="Προσθήκη Πληρωμής"
            title="Πατήστε για να επιλέξετε τον τρόπο με τον οποίο θα εξωφληθείτε το παραστατικό σας πριν την έκδοση του"
            severity="info"
            (onClick)="selectPaymentOption()"
        />
    } -->
    @if (allowSave == true) {
        <p-button label="Αποθήκευση" (onClick)="onSave()" />
    }
</div>
<div class="flex flex-auto flex-wrap justify-end gap-4">
    @if ((totalGrossValue ?? 0) > 0) {
        @if (showSendToAADEButton) {
            <p-button
                label="Πληρωμή & Έκδοση Παραστατικού"
                title="Πατήστε για επιλογή Τρόπου Πληρωμής, Έκδοση και Διαβίβαση παραστατικού στην Α.Α.Δ.Ε μέσω Παρόχου Ηλεκτρονικής Τιμολόγησης"
                severity="success"
                (onClick)="doSendToAADE($event)"
            />
        } @else {
            @if (correlateInvoice) {
                <p-button
                    label="Συσχέτιση Με Ψηφιακό Πελατολόγιο"
                    title="Πατήστε για ολοκληρωθεί η συσχέτιση του Παραστατικού με την εγγραφή του Ψηφιακού Πελατολογίου"
                    severity="warn"
                    icon="pi pi-link"
                    [iconPos]="'right'"
                    (onClick)="correlate()"
                />
            } @else {
                <!-- <p-button
                label="Συσχέτιση Με Ψηφιακό Πελατολόγιο....."
                title="Πατήστε για ολοκληρωθεί η συσχέτιση του Παραστατικού με την εγγραφή του Ψηφιακού Πελατολογίου"
                [text]="true"
                severity="help"
                icon="pi pi-link"
                [iconPos]="'right'"
                [disabled]="true"
            /> -->
            }
        }
    }

    <!-- Αφαιρούμε το κουμπάκι γιατί πλέον η διαβίβαση και η πληρωμή με κάρτα έιναι συγχρονιζμένα και όχι με παραστατικό τύπου πίστωσης και ετεροχρονισμένη χρέωση κάρτας -->
    <!-- @if (canDoPOSTransaction) {
        <p-button
            label="Αποδοχή Πληρωμής"
            title="Πατήστε για την αποδοχή Τραπεζικής Κάρτας από το Τερματικό Συναλλαγών (POS)"
            severity="warn"
            (onClick)="doPOSTransaction()"
        />
    } -->
</div>

@if (hasInvoiceValidMARK) {
    <!-- <p-button
            [outlined]="true"
            label="Έκδοση Παραστατικού"
            title="Πατήστε για την οριστική Έκδοση και Διαβίβαση του παραστατικού στην Α.Α.Δ.Ε μέσω Παρόχου Ηλεκρονικής Τιμολόγησης"
            severity="info"
            (onClick)="onSendToAADE()"
        /> -->
}

<div>
    <!-- <p-toast position="bottom-right" /> -->
    <p-confirmdialog>
        <ng-template #message let-message>
            <div
                class="flex flex-col gap-4 items-center w-full border-b border-surface-200 dark:border-surface-700 p-4 text-2xl"
            >
                <div class="flex flex-row flex-wrap gap-4">
                    <!-- <i
                        [ngClass]="message.icon"
                        class="text-8xl text-primary-500"
                        style="color: var(--p-button-warn-background)"
                    ></i> -->
                    <span>
                        {{ message.message }}
                    </span>
                    <!-- <span style="color: var(--p-button-info-focus-ring-color)">
                        {{ message.message }}
                    </span> -->
                </div>

                <!-- <p>
                    <span
                        class="text-base"
                        style="color: var(--p-button-danger-background)"
                        >Η ενέργεια αυτή δεν μπορεί να ακυρωθεί.</span
                    >
                </p> -->
            </div>
        </ng-template>
    </p-confirmdialog>
</div>
